<template>
  <div class="container px0">
    <div class="hero-video-wrapper">
      <div class="hero-video-aspect hero-video-aspect--desktop">
        <div v-if="!isDesktopLoaded" class="hero-video-placeholder">
          <Spinner />
        </div>
        <iframe
          v-if="shouldLoad"
          :src="desktopSrc"
          class="hero-video-iframe"
          :class="{ 'is-loaded': isDesktopLoaded }"
          frameborder="0"
          allow="autoplay; fullscreen"
          allowfullscreen
          loading="eager"
          @load="isDesktopLoaded = true"
        />
      </div>
      <div class="hero-video-aspect hero-video-aspect--mobile">
        <div v-if="!isMobileLoaded" class="hero-video-placeholder">
          <Spinner />
        </div>
        <iframe
          v-if="shouldLoad"
          :src="mobileSrc"
          class="hero-video-iframe"
          :class="{ 'is-loaded': isMobileLoaded }"
          frameborder="0"
          allow="autoplay; fullscreen"
          allowfullscreen
          loading="eager"
          @load="isMobileLoaded = true"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Spinner from 'theme/components/core/Spinner'

export default {
  name: 'HeroVimeoVideo',
  components: {
    Spinner
  },
  props: {
    vimeoIdDesktop: {
      type: [String, Number],
      required: true
    },
    vimeoIdMobile: {
      type: [String, Number],
      required: true
    }
  },
  data () {
    return {
      shouldLoad: false,
      isDesktopLoaded: false,
      isMobileLoaded: false
    }
  },
  computed: {
    desktopSrc () {
      return `https://player.vimeo.com/video/${this.vimeoIdDesktop}?autoplay=1&muted=1&loop=1&background=1&dnt=1`
    },
    mobileSrc () {
      return `https://player.vimeo.com/video/${this.vimeoIdMobile}?autoplay=1&muted=1&loop=1&background=1&dnt=1`
    }
  },
  mounted () {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(() => {
        this.shouldLoad = true
      })
    } else {
      setTimeout(() => {
        this.shouldLoad = true
      }, 100)
    }
  }
}
</script>

<style lang="scss" scoped>
.hero-video-wrapper {
  width: 100%;
  overflow: hidden;
}

.hero-video-aspect {
  position: relative;
  width: 100%;
  background-color: #fff;
}

.hero-video-aspect--desktop {
  display: none;
  padding-bottom: 42.94%; /* 1304:560 */

  @media (min-width: 768px) {
    display: block;
  }
}

.hero-video-aspect--mobile {
  display: block;
  padding-bottom: 176%;

  @media (min-width: 768px) {
    display: none;
  }
}

.hero-video-placeholder {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}

.hero-video-iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

 .container {
  @media (min-width: 1500px){
    width: 1306px;
  }
}
</style>
